document.addEventListener("DOMContentLoaded", function () {
  const tabButtons = document.querySelectorAll(".tabs-home__button");
  const tabContents = document.querySelectorAll(".tabs-home__content");

  tabButtons.forEach((button) => {
    button.addEventListener("click", () => {
      tabButtons.forEach((btn) => btn.classList.remove("active"));
      tabContents.forEach((content) => content.classList.remove("active"));

      button.classList.add("active");

      const buttonIndex = Array.from(tabButtons).indexOf(button);

      if (tabContents[buttonIndex]) {
        tabContents[buttonIndex].classList.add("active");
      }
    });
  });
});
